import React from 'react'
import { BusyButton } from '@ztechapps/webui.button'
import { Link, TooltipPopOver } from '@ztechapps/webui.util'
import { useGeneralSearchContext } from '../GeneralSearch'
import { useStoreAiChatOpenContext } from '../../AiChat/StoreAiChatOpenContext'
import { HeaderWidgetContainer } from '../header-widget/HeaderWidgetContainer'
import { IconOnCircle } from '../../icon-on-circle'
import styles from '../header-widget/index.module.scss'

/**
 * Header button that opens the storefront AI chat bubble and auto-seeds the
 * first message with whatever the user has typed in the GeneralSearch input.
 * Must be rendered inside both a GeneralSearchProvider (to read the current
 * search text) and a StoreAiChatOpenProvider (to trigger the bubble mounted
 * at the layout root).
 *
 * Two render variants gated by the lg breakpoint to match the surrounding
 * header pattern: a circular icon-only button on mobile/tablet that lines up
 * with the hamburger/search/cart icons (`ActionWidget` shape — same
 * `HeaderWidgetContainer` + `IconOnCircle` primitives), and the labeled
 * outline button on desktop where there's room for the "Search via AI" text.
 */
export const SearchViaAiButton = () => {
  const { search } = useGeneralSearchContext()
  const { open } = useStoreAiChatOpenContext()
  const handleClick = () => open(search ?? '')

  return (
    <>
      <div className="d-lg-none">
        <HeaderWidgetContainer>
          <TooltipPopOver tooltipBody="Open AI-assisted product search">
            <Link className={styles.widgetHeader} onClick={handleClick} aria-label="Search via AI">
              <IconOnCircle icon="wand-magic-sparkles" className="border" />
            </Link>
          </TooltipPopOver>
        </HeaderWidgetContainer>
      </div>

      <BusyButton
        variant="outline-light"
        title="Open AI-assisted product search"
        icon="wand-magic-sparkles"
        onClick={handleClick}
        className="d-none d-lg-flex align-items-center gap-1"
      >
        Search via AI
      </BusyButton>
    </>
  )
}
